import { authenticatedMiddleware } from '../permissions/middlewares/authenticatedMiddleware.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { registerMutation, registerSubscription } from '@adornis/baseql/metadata/register.js';
import { BeschaeftigungsGenehmigung } from './entities/beschaeftigungs-genehmigung.js';
import { resolveSubscribeEmploymenPermitsPerUser } from './list/server/resolveSubscribeEmploymenPermitsPerUser.js';
import { resolveSendEmploymentPermitEmail } from './mail/server/resolverSendEmploymentPermitEmail.js';

export const subscribeEmploymentPermitsForUser = registerSubscription({
  operationName: 'subscribeEmploymentPermitsForUser',
  middlewares: [authenticatedMiddleware],
  type: () => [BeschaeftigungsGenehmigung],
  params: [{ name: 'userID', type: () => ID }],
  resolve: resolveSubscribeEmploymenPermitsPerUser,
});

const sendEmploymentPermitEmail = registerMutation({
  operationName: 'sendEmploymentPermitEmail',
  middlewares: [authenticatedMiddleware],
  type: () => Boolean,
  params: [{ name: 'contractID', type: () => ID }],
  resolve: resolveSendEmploymentPermitEmail,
});

export const EmploymentPermitsAPI = {
  subscribeForUser: subscribeEmploymentPermitsForUser,
  sendBGADDMail: sendEmploymentPermitEmail,
};
